import { TextField, TextFieldSize } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { SearchField } from '~/components/search-field';

export const TextFieldStyled = styled(TextField).attrs({ size: TextFieldSize.MEDIUM })<{ disabled: boolean }>`
  ${({ theme, disabled }) => css`
    font-size: ${theme.fontSizes[300]};
    font-family: ${theme.fontFamilies['openSans']};
    background-color: ${disabled ? theme.colors.grey[100] : ''};
    :focus {
      box-shadow: none;
    }
    :disabled {
      opacity: 1;
    }
  `}
`;

export const SearchFieldContainerStyled = styled(SearchField)`
  :focus {
    box-shadow: none;
  }
`;
